import * as React from 'react';
import { Author } from './Author';

type Author = { name: string; link?: string };
export type AuthorsList = Author[];

interface AuthorsListProps {
  by: string;
  authors: AuthorsList;
  color: string;
}

const getPrefix = (index: number) => {
  return index > 0 ? ', ' : '';
};

export const AuthorsList: React.FunctionComponent<AuthorsListProps> = props => {
  const { authors, by, color } = props;

  return (
    <React.Fragment>
      {`${by} `}
      {authors.map((author, index) => <Author key={index} {...author} color={color} prefix={getPrefix(index)} />)}
    </React.Fragment>
  );
};
